package com.oscarherreros.appcalculo.game

/**
 * Racha del reto diario. [lastCompletedDay] es el día del último reto
 * completado, [streak] los días seguidos que llevaba entonces y [stars] la
 * mejor puntuación conseguida en ese reto.
 *
 * Los días se cuentan desde el 1 de enero de 1970, como `LocalDate.toEpochDay`,
 * para no depender de las fechas de Java y poder usarlo en cualquier plataforma.
 */
data class DailyProgress(val lastCompletedDay: Long? = null, val streak: Int = 0, val stars: Int = 0) {
    fun isCompleted(today: Long): Boolean = lastCompletedDay == today

    /** Mejor puntuación en el reto de [today]; 0 si aún no se ha completado. */
    fun starsOn(today: Long): Int = if (isCompleted(today)) stars else 0

    /** La racha sigue viva mientras se haya completado el reto de hoy o el de ayer. */
    fun currentStreak(today: Long): Int =
        if (lastCompletedDay != null && lastCompletedDay >= today - 1) streak else 0

    /** Repetir el reto del día no alarga la racha: solo cuenta si mejora la puntuación. */
    fun complete(today: Long, stars: Int): DailyProgress =
        if (isCompleted(today)) {
            copy(stars = maxOf(this.stars, stars))
        } else {
            DailyProgress(today, currentStreak(today) + 1, stars)
        }
}
